import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { mapGraphQLErrors } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { Schema } from '../../schema'
import { Data, REQUEST_RESET_PASSWORD, Variables } from './api'
import { UseRequestResetPassword } from './types'

export const useRequestResetPassword = (): UseRequestResetPassword => {
  const { t } = useTranslation('features/user')
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: REQUEST_RESET_PASSWORD,
    onCompleted: async (data: Data): Promise<void> => {
      const { requestResetPassword } = data

      // TODO: 'requestResetPassword' should never be null in API response. Backend needs to be fixed.
      if (requestResetPassword?.errors && requestResetPassword?.errors.length > 0) {
        setErrors(mapGraphQLErrors(requestResetPassword.errors))
      } else {
        setErrors({})
        enqueueSnackbar(t('userRequestPassword.form.success'), {
          variant: 'success',
        })
      }
    },
  })

  const requestResetPassword = (data: Schema): void => {
    void mutateAsync({
      input: data,
    })
  }

  return {
    errors,
    loading: isPending,
    requestResetPassword,
  }
}
